import React from 'react';
import { motion } from 'framer-motion';

const variants = {
    fadeUp: {
        hidden: { opacity: 0, y: 40 },
        visible: { opacity: 1, y: 0 },
    },
    fadeIn: {
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
    },
    fadeLeft: {
        hidden: { opacity: 0, x: -40 },
        visible: { opacity: 1, x: 0 },
    },
    fadeRight: {
        hidden: { opacity: 0, x: 40 },
        visible: { opacity: 1, x: 0 },
    },
};

const ScrollReveal = ({ children, variant = 'fadeUp', delay = 0, duration = 0.6, style, className }) => {
    return (
        <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration, delay, ease: 'easeOut' }}
            variants={variants[variant]}
            style={style}
            className={className}
        >
            {children}
        </motion.div>
    );
};

export default ScrollReveal;
